<template>
    <div class="auth__twofactorauthhelp_form">
        <div class="container">
            <div class="columns is-variable">
                <div class="column">
                    <div class="auth__twofactorauthhelp_form_box">
                        <div class="auth__twofactorauthhelp_form_box_title">{{ $t('auth.twoFactorHelp.title.troubleReceivingCode') }}</div>
                        <div class="auth__twofactorauthhelp_form_box_list">
                            <ul>
                                <li class="auth__twofactorauthhelp_form_box_list_item">
                                    <div class="auth__twofactorauthhelp_form_box_list_item_title">{{ $t('auth.twoFactorHelp.title.howDoesWork') }}</div>
                                    <div class="auth__twofactorauthhelp_form_box_list_item_link">
                                        <component-button
                                            :theme="'primary'"
                                            :text="true"
                                            :underline="true"
                                            :size="''"
                                            :name="'auth-twofactorauthhelp-form-box-list-item-link-learnmore'"
                                        >{{ $t('auth.twoFactorHelp.buttons.learnMore') }}</component-button>
                                    </div>
                                </li>
                                <li class="auth__twofactorauthhelp_form_box_list_item">
                                    <div class="auth__twofactorauthhelp_form_box_list_item_title">{{ $t('auth.twoFactorHelp.title.authenticationCode') }}</div>
                                    <div class="auth__twofactorauthhelp_form_box_list_item_link">
                                        <component-button
                                            :theme="'primary'"
                                            :text="true"
                                            :underline="true"
                                            :size="''"
                                            :name="'auth-twofactorauthhelp-form-box-list-item-link-sign'"
                                        >{{ $t('auth.twoFactorHelp.buttons.signWithCode') }}</component-button>
                                    </div>
                                </li>
                                <li class="auth__twofactorauthhelp_form_box_list_item">
                                    <div class="auth__twofactorauthhelp_form_box_list_item_title">{{ $t('auth.twoFactorHelp.title.stillHavingTrouble') }}</div>
                                    <div class="auth__twofactorauthhelp_form_box_list_item_link">
                                        <component-button
                                            :theme="'primary'"
                                            :text="true"
                                            :underline="true"
                                            :size="''"
                                            :name="'auth-twofactorauthhelp-form-box-list-item-link-help'"
                                        >{{ $t('auth.twoFactorHelp.buttons.getFurtherHelp') }}</component-button>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="auth__twofactorauthhelp_form_box_actions">
                            <component-button
                                :theme="'default'"
                                :size="'full'"
                                :icon="true"
                                :icon-position="'left'"
                                :icon-name="'arrow-left'"
                                :to="{ name: 'auth-login' }"
                                :name="'auth-twofactorauthhelp-form-box-list-item-link-backtologin'"
                            >{{ $t('auth.twoFactorHelp.buttons.backToLogin') }}</component-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  name: 'auth-twofactorauthhelp-form',
  components: { ComponentButton }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/auth/twofactorauthhelp/authtwofactorauthhelpform";
</style>
